import Button from "comps/Button";
import Input from "comps/Input";
import React, { useState } from "react";
import { Controller, useForm,   } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { onBoardingDataTypes } from "utils/types";
import { onboardingSchema } from "validations";
import { onboardUser } from "services";
import { useUserAuthContext } from "context/UserAuthContext";
import toast from "react-hot-toast";
 
const Onboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const {
    // setUserDetails,
    userDetails: {
      token,
      user: { userId, phoneNumber, email },
    },
  } = useUserAuthContext();
 

	const { handleSubmit, control, formState: { errors },} = useForm<onBoardingDataTypes>({
		reValidateMode: "onBlur",
		defaultValues: {
		email: email || location?.state?.email || "",
		businessName: "",
		phoneNumber: phoneNumber || "",
		},
		resolver: yupResolver(onboardingSchema),
	});

	const handleOboard = async (data: any) => {
		if (loading) return;
		setLoading(true);
			const res = await onboardUser({
			userId: userId,
			token: token,
			businessName: data.businessName,
			email: data.email,
			phoneNumber: data.phoneNumber,
			...data
		});
		setLoading(false);
		if (res.status >= 200 && res.status < 299) {
			toast.success(`Success: User Onboaded`, { duration: 3000, });
			// setUserDetails(res?.data?.data);
			// localStorage.setItem("authDetails", JSON.stringify(res?.data?.data));
			navigate("/integration", { replace: true });
			return;
		} else {
		return toast.error(`Error: ${res?.data?.error}`, {
			duration: 3000,
		});
		}
	};

 

  return (
    <div className="bg-white min-h-screen">
      <h1 className="m-5 text-primary500 w-full font-semibold font-openSans text-xl">
        SAFEPro
      </h1>

      <h1 className="text-safeproblack mt-5 md:mt-10 text-center text-lg md:text-3xl font-semibold">
		Required Information
      </h1>
      <p className="text-[#404345] text-center text-sm md:text-base mt-5 px-3 md:px-0">
        Fill in the following details about your business to get started with
        SAFEPro
      </p>
      <p className="text-[#6B7280] text-center text-xs md:text-sm mt-2 px-3 md:px-0">
        Logo and brand colours can be updated later in Settings when you want to use OTP redirect.
      </p>
      <form onSubmit={handleSubmit(handleOboard)}>
        <div className="w-11/12 md:w-7/12 mx-auto mt-5 md:mt-14 grid grid-cols-1 md:gap-x-32">
          <Controller
            name="businessName"
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <Input
                type="text"
                label="Business Name"
                placeholder="Enter business name"
                className="mb-5"
                onBlur={onBlur}
                onChange={onChange}
                value={value}
                error={errors?.businessName?.message}
              />
            )}
          />

          <Controller
            name="email"
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <Input
                type="text"
                label="Email"
                placeholder="Enter email address"
                className="mb-5"
                onBlur={onBlur}
                onChange={onChange}
                value={value}
                error={errors?.email?.message}
                disabled={email || location?.state?.email}
              />
            )}
          />

          <Controller
            name="phoneNumber"
            control={control}
            render={({ field: { onChange, onBlur, value } }) => (
              <Input
                type="number"
                label="Phone Number"
                placeholder="Enter phone number"
                className="mb-5"
                onBlur={onBlur}
                onChange={onChange}
                value={value}
                error={errors?.phoneNumber?.message}
                disabled={phoneNumber}
              />
            )}
          />
        </div>
        <Button
          btnText="Save Details"
          type="submit"
          className="w-40 mx-auto flex justify-center mt-5 drop-shadow-md"
        >
          {loading ? "..." : ""}
        </Button>
      </form>
    </div>
  );
};

export default Onboard;
